import LocalDatabase from '@/includes/db';
import { Schema } from '@/includes/definitions/index.d';
import { CardGameHistory } from '@/includes/definitions/word.d';

const schema = {
  name: 'CardGameHistory',
  keyPath: 'id',
  autoIncrement: true,
  timestamps: true,
  schema: {
    id: { unique: true },
    title: { unique: false },
    score: { unique: false },
    words: { unique: false },
  },
} as Schema;

export const CardGameHistoryModel = LocalDatabase.MakeModel<CardGameHistory>(schema);
export default schema;
